import { FlowDefinition } from "../../core/flows/FlowDefinition";
import { StepDefinition } from "../../core/flows/StepDefinition";
import { PlanMultiBookInitStepDeclaration } from "./Steps/PlanMultiBookInitStep";

export const PlanMultiBookStartupFlow = new FlowDefinition("PlanMultiBookFlow");

PlanMultiBookStartupFlow.addStep(PlanMultiBookInitStepDeclaration);

PlanMultiBookStartupFlow.setStartStep("PlanMultiBookInit_Step");

export const PlanMultiBookStartupStepDefinition = new StepDefinition({
    stepName: "PlanMultiBookFlow",
    stepFlow: PlanMultiBookStartupFlow,
    contextIsolation: false
})
